import { Helmet } from "react-helmet";
import { Spinner } from "../Spinner/Spinner";

export type LoadingContentContainerProps = {
    title?: string
}

export function LoadingContentContainer(props: LoadingContentContainerProps) {
    return (
        <div className="px-4 md:px-8 pt-8 pb-24">
            <Helmet>
                <title>
                    {
                        props.title
                            ? props.title
                            : "Materia Hunter"
                    }
                </title>
            </Helmet>
            <div className="h-[36px] w-[200px]"></div>
            <div className="mt-16">
                <Spinner />
            </div>
        </div>
    )
}